import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import { Intro } from "./components/Intro";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail, { NotFoundBlock } from "./pages/ProductDetail";
import Consulting from "./pages/Consulting";
import Insights from "./pages/Insights";
import ArticleDetail from "./pages/ArticleDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const PublicLayout = () => (
  <>
    <Intro />
    <Header />
    <Outlet />
    <Footer />
  </>
);

const AdminLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<ArticleDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFoundBlock to="/" label="Back to home" />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="login" element={<AdminLogin />} />
            <Route index element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Route>
        </Routes>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1E5250", color: "#E4E2DD", border: "none" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
